import { Component, OnInit } from '@angular/core';
import { BaseGridTemplate } from '../../../../../shared/cgp-grid/base-cgp-grid.template';
import { Validators, FormBuilder, FormGroup, FormControl, UntypedFormGroup } from '@angular/forms';
import { SystemPhaseDetail } from '../../../../../shared/domain/camtl/SystemPhaseDetail';
import { BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs';


import {
  DateTemplateService,
  SystemPhaseService,
  SystemPhaseDetailService,
  DateTemplateSystemPhaseService
} from '../../../camtl.service';


@Component({
  selector: 'app-manage-date-template',
  templateUrl: './manage-date-template.component.html',
})
export class ManageDateTemplateComponent extends BaseGridTemplate implements OnInit {
  selectedTemplate: any = undefined;
  templateValue: any;
  isChanged: boolean;
  dateTemplate: BehaviorSubject<any[]>;
  customFormDialogTemplate: Subject<any> = new BehaviorSubject<any>(undefined);
  systemPhases: any[];
  availSystemPhases: any[];
  isAddNew: boolean;

  private selectedSystemPhases: Subject<any[]> = new BehaviorSubject<any[]>([]);
  private availablesystemPhases: Subject<any[]> = new BehaviorSubject<any[]>([]);

  constructor(
    private formBuilder: FormBuilder,
    public systemPhaseDetailService: SystemPhaseDetailService,
    public dateTemplateService: DateTemplateService,
    public systemPhaseService: SystemPhaseService,
    public dateTemplateSystemPhaseService: DateTemplateSystemPhaseService,
  ) { super(); }


  ngOnInit() {
    this.dateTemplate = this.dateTemplateService;
    this.dateTemplateService.query()
    this.systemPhaseService.query();

    this.selectedSystemPhases.subscribe(x => this.systemPhases = x);
    this.availablesystemPhases.subscribe(x => this.availSystemPhases = x)
  }

  gridFilter: boolean;

  /**
   * Filter dropdown input text
   * @param dataItem input/partial input
   */
  handleFilter(dataItem: any) {
    // try {
    //   this.templates = this.dateTemplates.data
    //     .filter(item => item.TemplateName.toLowerCase()
    //       .indexOf(dataItem.toLowerCase() !== -1));
    // } catch (e) { }
  }


  /**
   * Template dropdown
   */
  handleValueChange(dataItem: any = undefined) {
    this.templateValue = dataItem;
    this.selectedTemplate = dataItem;
    if (dataItem != undefined) {
      this.template.fileName = "DateTemplate - " + dataItem.TemplateName + ".xlsx";
    }
    this.gridFilter = !this.gridFilter;
  }


  customSaveHandler(dataItem: any) {
    let selected = this.selectedTemplate;
    //this.handleValueChange();
    if (this.isAddNew) {
      this.dateTemplateService.save(dataItem, true)
        .then(() => {
          this.dateTemplateService.read()
            .then((data) => {
              selected = data.find(item => item.TemplateName === dataItem.TemplateName);
              this.handleValueChange(selected);
            })
        });
      this.isAddNew = false;
      this.gridFilter = !this.gridFilter;
      return;
    }

    dataItem.systemPhaseDetailDto = this.systemPhases
      .map((item, i) => {
        if (!item.SystemPhaseId) {
          item = {
            SystemPhaseId: item.Id,
            AnchorDays: 0,
            IsActualEditable: !item.IsRequired,
            Status: true,
          }
        }
        item.DisplayOrder = i;
        return item;
      })

    this.systemPhaseDetailService.save(dataItem, true)
      .then(() => this.handleValueChange(selected));

    this.customFormDialogTemplate.next(undefined);
    this.selectedSystemPhases.next([]);
  }

  customCancelHandler() {
    this.customFormDialogTemplate.next(undefined);
    this.selectedSystemPhases.next([]);
  }


  /****************************************************************************
   * System Phase
   ***************************************************************************/

  /**
   * Filter and sort system phases into available and assigned.
   * Required system phases are automatically added to assigned
   */
  updateSystemPhases = () => {
    let all = this.systemPhaseService.value,
      current = this.dateTemplateSystemPhaseService.value.map(x => x),
      available = all.filter(x => !current.some(c => c.SystemPhaseId === x.Id) && !x.IsRequired);


    this.availablesystemPhases.next(available);

    current.map(item => {
      try {
        item.initial = true;
        item.IsRequired = all.find(x => x.Id === item.SystemPhaseId).IsRequired;
      } catch (e) { }
      return item;
    })

    this.systemPhaseService.value
      .forEach(x => {
        if (x.IsRequired && !current.some(c => c.SystemPhaseId === x.Id))
          current.unshift(x);
      })
    this.selectedSystemPhases.next(current);

    this.updateSystemPhaseTemplate();
  }


  updateSystemPhaseTemplate() {
    if (!this.selectedTemplate) return;

    let editForm: UntypedFormGroup = new UntypedFormGroup({
      DateTemplateId: new FormControl(''),
      systemPhaseDetailDto: new FormControl({ value: [], disabled: false }),
    });

    let dataItem: any = {
      DateTemplateId: this.selectedTemplate.Id,
    }

    editForm.reset(dataItem);

    let template = {
      title: this.systemPhaseformDialog.title,
      editForm: editForm,
      isNew: false,
      formControls: this.systemPhaseformDialog.formControls,
    }

    this.customFormDialogTemplate.next(template);
  }

  getDisabledIndexes(n): number[] {
    let arr: number[] = [];
    for (var i = 0; i < n; i++) {
      arr.push(i);
    }
    return arr;
  }


  handleSystemPhaseAddSelected = (data) => {
    this.selectedSystemPhases.next(data);
  }


  handleSortableDrag = (data, e) => {
    this.selectedSystemPhases.next(data);
  }


  handleSystemPhaseRemoveSelected = (data, e) => {
    let dataItem = e.dataItem;
    if (dataItem.initial || dataItem.IsRequired) {
      e.preventDefault();
    }
    this.selectedSystemPhases.next(data);
  }


  handleSystemPhaseAddAvailable = (data, e) => {
    let dataItem = e.dataItem;
    if (dataItem.initial || dataItem.IsRequired) {
      e.preventDefault();
    }
    this.availablesystemPhases.next(data);
  }


  availableSystemPhasesControl = {
    zone: 'sysPhase',
    title: 'Available',
    textField: 'Name',
    valueField: 'Id',
    service: this.availablesystemPhases,
    disabledIndexes: [],
    add: this.handleSystemPhaseAddAvailable,
    // remove: this.handleSystemPhaseRemoveAvailable
  };

  selectedSystemPhasesControl = {
    zone: 'sysPhase',
    title: 'Assigned',
    name: "systemPhaseDetailDto",
    emptyText: "Move System Phases from Available to Assigned.",
    textField: 'Name',
    valueField: 'Id',
    service: this.selectedSystemPhases,
    add: this.handleSystemPhaseAddSelected,
    remove: this.handleSystemPhaseRemoveSelected,
    drag: this.handleSortableDrag,
    disabledIndexes: [],
  }

  systemPhaseformDialog = {
    title: "System Phase",
    formControls: [{
      type: "sortable",
      title: "System Phase",
      containers: [
        this.availableSystemPhasesControl,
        this.selectedSystemPhasesControl,
      ]
    }]
  }


  addEditSystemPhaseControl = {
    id: "updateSystemPhases",
    iconClass: "fa fa-retweet",
    title: "Add | Edit System Phases",
    text: "Add | Edit System Phases",
    primary: true,
    callback: this.updateSystemPhases,
  }


  /****************************************************************************
   * Date Template
   ***************************************************************************/
  handleAddDateTemplate = () => {
    this.isAddNew = true;
    let editForm: FormGroup = new FormGroup({
      TemplateName: new FormControl('', Validators.required),
      IsActive: new FormControl(true),
    });

    let dataItem: any = { IsActive: true };

    editForm.reset(dataItem);

    let template = {
      title: this.dateTemplateFormDialog.title,
      editForm: editForm,
      isNew: true,
      formControls: this.dateTemplateFormDialog.formControls,
    }
    this.customFormDialogTemplate.next(template);
  }


  dateTemplateFormDialog = {
    title: "Date Template",
    formControls: [{
      type: "text",
      name: "TemplateName",
      title: "Template Name",
    }]
  }

  addNewDateTemplateControl = {
    id: "dateTemplate",
    iconClass: "fa fa-plus",
    title: "Add New Date Template",
    text: "Add New Date Template",
    callback: this.handleAddDateTemplate,
  }


  /****************************************************************************
   * Grid - Date Template System Phase
   ***************************************************************************/
  handleControlDisabled = (controlName: string) => {
    let isDisabled: boolean = false;
    switch (controlName) {
      case 'excel':
        isDisabled = this.selectedTemplate === undefined;
        break;
      case 'updateSystemPhases':
        isDisabled = this.selectedTemplate === undefined;
        break;
      default:
        break;
    }
    return isDisabled;
  }


  handleRead = () => {
    return this.selectedTemplate ?
      this.dateTemplateSystemPhaseService
        .read('/' + this.selectedTemplate.Id + '/systemphases', true)
        .then(data => data.map(item => {
          let systemPhase = this.systemPhaseService.value
            .find(x => x.Id === item.SystemPhaseId);
          item.IsRequired = systemPhase.IsRequired;
          item.Name = item.SystemPhaseName;
          return item;
        })) :
      Promise.resolve([]);
  }


  handleSave = (dataItem: any, isNew: boolean) => {
    let editDataItem: any = {
      DateTemplateId: this.selectedTemplate.Id,
      systemPhaseDetailDto: [dataItem]
    }

    return this.systemPhaseDetailService
      .save(editDataItem, false)
  }


  setModelHandler() {
    this.editDataItem = new SystemPhaseDetail();
  }


  handleEdit = (dataItem, isDetailRow) => {
    this.editForm.removeControl('Status');
    this.editForm.removeControl('IsActualEditable');
    let systemPhase = this.systemPhaseService.value
      .find(x => x.Id === dataItem.SystemPhaseId);
    if (systemPhase.IsRequired) {
      this.editForm.addControl('Status', new FormControl([]));
      this.editForm.addControl('IsActualEditable', new FormControl([]));
    }
  }


  editForm: UntypedFormGroup = this.formBuilder.group({
    AnchorDays: [0, Validators.required],
    Status: [true, Validators.required],
    IsActualEditable: [false, Validators.required],
    DisplayOrder: [],
    Id: [],
    SystemPhaseId: [],
  });

  formDialog = {
    title: "Date Template System Phase",
    formControls: [{
      type: "number",
      name: 'AnchorDays',
      title: 'Anchor Days',
      minimum: -365,
      maximum: 365,
      default: 0,
    },
    {
      type: 'boolean',
      name: 'Status',
      title: 'Activate',
    },
    {
      type: 'boolean',
      name: 'IsActualEditable',
      title: 'Actual Not Editable',
    }]
  }

  columns = [
    {
      field: 'SystemPhaseName',
      title: 'System Phase Name'
    },
    {
      field: 'AnchorDays',
      title: 'Anchor Days (+ or -)',
    },
    {
      field: 'Status',
      title: 'Activate',
      template: {
        type: 'boolean',
        onLabel: 'Yes',
        offLabel: 'No',
        operation: 'equals',
        field: 'IsRequired'
      }
    },
    {
      field: 'IsActualEditable',
      title: 'Actual Not Editable',
      template: {
        type: 'boolean',
        onLabel: 'Yes',
        offLabel: 'No',
        operation: 'equals',
        field: 'IsRequired'
      }
    },
  ]

  template = {
    title: 'Date Template System Phase',
    controls: {
      add: false,
      edit: true,
      delete: false,
      excel: true,
      width: 65,
      customToolbar: [
        this.addNewDateTemplateControl,
        this.addEditSystemPhaseControl,
      ],
      isDisabled: this.handleControlDisabled,
    },
    columns: this.columns,
    service: this.dateTemplateService,
    read: this.handleRead,
    save: this.handleSave,
    edit: this.handleEdit,
    fileName: 'DateTemplates.xlsx'
  }


}
